module.exports = __webpack_public_path__ + "img/Press-Download-Arrow.ea829126.svg";